import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Group } from '../common/Group.type'
import { RootState } from '../common/RootState.type'

const groups: Group[] = []

const initialState = { groups }

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    resetGroup: (state, action: PayloadAction<Group[]>) => {
      state.groups = action.payload
    },
    addGroup: (state, action: PayloadAction<Group>) => {
      state.groups.push(action.payload)
    },
    removeGroup: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        groups: state.groups.filter((group) => group.id !== action.payload),
      }
    },
    editGroup: (state, action: PayloadAction<Group>) => {
      state.groups = state.groups.map((group) =>
        group.id === action.payload.id ? action.payload : group,
      )
    },
  },
})

export const selectGroups = (state: RootState) => state.group.groups

export const { resetGroup, addGroup, removeGroup, editGroup } =
  groupSlice.actions
